import { BACKEND_API_URL } from './api';

export type AdminEnvironment = 'production' | 'staging';

export const ADMIN_URLS: Record<AdminEnvironment, string> = {
  production: 'https://admin.offseasonwellness.com',
  staging: 'https://staging-admin.offseasonwellness.com',
};

export const CURRENT_ENVIRONMENT: AdminEnvironment = BACKEND_API_URL.includes('staging')
  ? 'staging'
  : 'production';

export function environmentUrl(target: AdminEnvironment, path: string, search: string, hash: string): string {
  return `${ADMIN_URLS[target]}${path}${search}${hash}`;
}

export interface BackendBuild {
  environment: string;
  git_sha: string | null;
}

export async function getBackendBuild(): Promise<BackendBuild> {
  const response = await fetch(`${BACKEND_API_URL}/health/build`);
  if (!response.ok) {
    throw new Error(`Backend build info failed: ${response.status}`);
  }
  return response.json();
}
